var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.5 9.75C19.5 15.1125 15.1125 19.5 9.75 19.5C4.3875 19.5 0 15.1125 0 9.75C0 4.3875 4.3875 0 9.75 0C15.1125 0 19.5 4.3875 19.5 9.75ZM9.75 4.875C8.0925 4.875 6.825 6.1425 6.825 7.8C6.825 9.4575 8.0925 10.725 9.75 10.725C11.4075 10.725 12.675 9.4575 12.675 7.8C12.675 6.1425 11.4075 4.875 9.75 4.875Z",
    fill: "#D4D4DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75001 19.5C12.285 19.5 14.625 18.525 16.2825 16.965C15.5025 14.5275 12.87 12.675 9.75001 12.675C6.63 12.675 3.9975 14.5275 3.21749 16.965C4.875 18.525 7.215 19.5 9.75001 19.5Z",
    fill: "#D4D4DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.bb87ab784ab6a714ecc748700cd43f5b.svg";
export { ForwardRef as ReactComponent };